var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-002fbc21\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./HomePageDownView.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/HomePage/HomePageDownView.vue
// module id = 373
// module chunks = 1